<script>
export default {
    name: "WeiveredBillsReport",

    data() {

        return {
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                search: ``,
            },
            bills: [],
        };
    },

    computed: {

        totalWeivered() {

            if(!this.bills.length) return 0;

            return this.bills.map(bill => bill.weiveredAmount ? parseFloat(bill.weiveredAmount) : 0)
                .reduce((sum, amt) => sum + amt)
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchWeiveredBills(), ]);
    },

    methods: {

        fetchWeiveredBills() {
            this.$root.loading = true;
            let url = `AccountsReports/GetWeiveredBIlls?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
            return this.$http.get(url).then(response => {
                this.bills = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        printWeiveredBillsReport() {

            window.open(`/reports/accounts-finance/weivered-bills-report/print?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}&search=${this.filter.search}`,
             '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printWaiver(billNo, patientID) {
            let url = `/reports/accounts-finance/weivered-bills-details/print`;
                url += `?BillNo=${billNo}&PatientID=${patientID}`;
            
            window.open(
             url,
             '_blank', 
             `ReportPrint`, 
             "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `reports.accounts-finance.index` }">Accounts & Finance Reports</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Waivered patient bills</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Waivered patient bills</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="$root.checkAuth('AccessOldData')
                ">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom"
                    id="grid-date-from" class="input-control input-sm text-xs" >
              </div> 
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="!$root.checkAuth('AccessOldData')">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" :min="$root.minFilterDate"
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchWeiveredBills"><i class="fa fa-filter"></i> Filter</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-primary text-xs rounded" @click.prevent="$root.exportToExcel(`weivered-bills-report`, `weiveredBillsReport`)"><i class="fa fa-file-excel"></i> Export</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button
                    @click.prevent="printWeiveredBillsReport"
                    class="btn-sm btn-info text-xs rounded">
                        <i class="fa fa-print"></i> Print</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="weiveredBillsReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/4">Patient</th>
                            <th class="p-tiny flex-1">Bill No</th>
                            <th class="p-tiny flex-1">Date</th>
                            <th class="p-tiny flex-1">Reason</th>
                            <th class="p-tiny flex-1">Approved By</th>
                            <th class="p-tiny flex-1">Bill Amt</th>
                            <th class="p-tiny flex-1">Weivered Amt</th>
                            <th class="p-tiny w-1/12">Action</th>
                        </tr>
                  </thead>
                  <tfoot class="text-sm font-medium">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/2"></th>
                            <th class="p-tiny w-1/2 text-right">Total: {{ totalWeivered | numberFormat }}</th>
                        </tr>
                  </tfoot>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="w-full flex" v-for="(bill,idx) in bills" :key="idx">
                          <td class="p-tiny w-1/4">{{ bill.patient }}</td>
                          <td class="p-tiny flex-1">{{ bill.billNo }}</td>
                          <td class="p-tiny flex-1">{{ bill.txnDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ bill.reason }}</td>
                          <td class="p-tiny flex-1">{{ bill.approvedBy }}</td>
                          <td class="p-tiny flex-1">{{ bill.billAmount | numberFormat }}</td>
                          <td class="p-tiny flex-1">{{ bill.weiveredAmount | numberFormat }}</td>
                          <td class="p-tiny w-1/12">
                            <button
                                @click.prevent="printWaiver(bill.billNo, bill.patientID)" 
                                class="btn-sm btn-info text-xs rounded">
                                    <i class="fa fa-print"></i> Print</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
